import React from "react";
import { Link } from "react-router-dom";

/**
 * OrderPage Component
 * - External order CTA
 * - Redirects to order platform
 * - Simple centered layout
 */
function OrderPage() {
  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <header className="bg-gray-900 text-white py-12">
        <div className="max-w-screen-xl mx-auto px-4 sm:px-6 lg:px-8">
          <Link
            to="/"
            className="text-amber-700 hover:text-amber-800 mb-4 inline-block"
          >
            ← Back to Home
          </Link>
          <h1 className="text-4xl sm:text-5xl font-bold">
            PLACE YOUR ORDER
          </h1>
        </div>
      </header>

      {/* Main Content */}
      <section className="py-24">
        <div className="max-w-2xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-6">
            Order Online Today
          </h2>
          <p className="text-lg text-gray-600 mb-8 leading-relaxed">
            Experience our delicious cuisine with fast, reliable
            online ordering. Choose from our extensive menu and
            have your meal delivered fresh to your door.
          </p>

          {/* Order Button */}
          <a
            href="https://direct.chownow.com/order/40093/locations?add_cn_ordering_class=true"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block bg-amber-700 hover:bg-amber-800 text-white px-10 py-4 sm:px-12 sm:py-5 rounded-lg font-semibold text-lg transition-all duration-300 hover:shadow-lg transform hover:-translate-y-1 mb-8"
          >
            Place Your Order Now →
          </a>

          {/* Alternative Contact */}
          <div className="border-t pt-12 mt-12">
            <h3 className="text-2xl font-bold text-gray-900 mb-6">
              Prefer to Call?
            </h3>
            <a
              href="tel:973-350-6522"
              className="inline-block text-xl text-amber-700 hover:text-amber-800 font-semibold transition-colors"
            >
              973-350-6522
            </a>
            <p className="text-gray-600 mt-4">
              Our team is ready to help with your order
            </p>
          </div>
        </div>
      </section>

      {/* Info Section */}
      <section className="bg-gray-50 py-16">
        <div className="max-w-screen-xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div className="text-center">
              <div className="text-3xl mb-3">🚚</div>
              <h3 className="font-bold text-gray-900 mb-2">
                Fast Delivery
              </h3>
              <p className="text-gray-600">
                Quick and reliable delivery to your location
              </p>
            </div>
            <div className="text-center">
              <div className="text-3xl mb-3">🍽️</div>
              <h3 className="font-bold text-gray-900 mb-2">
                Quality Food
              </h3>
              <p className="text-gray-600">
                Fresh, authentic cuisine every time
              </p>
            </div>
            <div className="text-center">
              <div className="text-3xl mb-3">💳</div>
              <h3 className="font-bold text-gray-900 mb-2">
                Easy Payment
              </h3>
              <p className="text-gray-600">
                Multiple payment options available
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default OrderPage;
